import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';
import { AuthGuard } from '../components/Auth/AuthGuard';
import { AppShell } from '../components/layout/AppShell';
import { AppHeader } from '../components/layout/AppHeader';

export const Route = createFileRoute('/settings')({
  component: () => <AuthGuard><AppShell><SettingsLayout /></AppShell></AuthGuard>,
});

const SECTIONS = [
  { to: '/settings/profile', label: 'Profile' },
  { to: '/settings/billing', label: 'Billing & credits' },
  { to: '/settings/team', label: 'Team' },
  { to: '/settings/api', label: 'API & connector' },
  { to: '/settings/advanced', label: 'Advanced' },
] as const;

function SettingsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const current = SECTIONS.find((s) => pathname.startsWith(s.to));

  return (
    <div className="h-full overflow-y-auto bg-background">
      <AppHeader />
      <div className="mx-auto max-w-5xl px-4 py-6 md:px-6 md:py-8">
        <p className="text-sm text-muted-foreground">Settings{current ? ` / ${current.label}` : ''}</p>
        <h1 className="mt-1 text-2xl font-bold">{current?.label ?? 'Settings'}</h1>
        <div className="mt-6 grid gap-6 md:grid-cols-[180px_minmax(0,1fr)]">
          <nav aria-label="Settings" className="flex gap-1 overflow-x-auto md:flex-col md:overflow-visible">
            {SECTIONS.map((s) => (
              <Link
                key={s.to}
                to={s.to}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground"
                activeProps={{ className: 'bg-card text-foreground shadow-[0_0_0_1px_hsl(var(--border))]' }}
              >
                {s.label}
              </Link>
            ))}
          </nav>
          <main className="min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
}
